import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsUnblindingRequestManagementServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestManagementServices";

const ReviewStudyUnblindRequestManagement = ({
  requestData,
  getEIWRSUnblindingRequestData,
  getEIWRSUnblindingRequestStats,
  Show,
  Hide,
  Title,
  setRequestId,
}) => {
  const { studyId } = useParams()
  const [status, setStatus] = useState("");
  const [accessDuration, setAccessDuration] = useState("");
  const [decisionComment, setDecisionComment] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const reviewEIWRSUnblindingRequestData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Review this request!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, review it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = requestData?._id;
        userData.studyId = studyId;
        userData.status = status;
        userData.accessDuration = accessDuration;
        userData.decisionComment = decisionComment;
        userData.mode = StudyMode;
        let data = await eiwrsUnblindingRequestManagementServices.reviewEIWRSUnblindingRequestData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSUnblindingRequestData();
          getEIWRSUnblindingRequestStats();
          Hide();
          setRequestId("");
          setAccessDuration("");
          setDecisionComment("");
          setStatus("");
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Status <abbr title="Required" className="text-danger"> *</abbr>
            </Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="br3" style={{ fontSize: 12 }}>
              <option value="">Select Status</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
              <option value="cancelled">Cancelled</option>
            </Form.Select>
          </Form.Group>
          {status === "approved" &&
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Access Duration <abbr title="Required" className="text-danger"> *</abbr>
              </Form.Label>
              <Form.Select
                value={accessDuration}
                onChange={(e) => setAccessDuration(e.target.value)}
                className="br3" style={{ fontSize: 12 }}>
                <option value="">Select Access Duration</option>
                <option value="1hr">1 hour</option>
                <option value="3hr">3 hours</option>
                <option value="6hr">6 hours</option>
                <option value="12hr">12 hours</option>
                <option value="1d">1 Day</option>
                <option value="1w">1 Week</option>
                <option value="2w">2 Week</option>
                <option value="1m">1 Month</option>
                <option value="3m">3 Months</option>
                <option value="6m">6 Months</option>
                <option value="1y">1 Year</option>
                <option value="permanent">Permanent</option>
``              </Form.Select>
            </Form.Group>
          }
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Decision Comment <abbr title="Required" className="text-danger"> *</abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setDecisionComment(e.target.value)}
              value={decisionComment}
              className="br3"
              placeholder="Enter Decision Comment"
              as="textarea"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={
              !status ||
              (
                status === "approved"
                  ? (!accessDuration || !decisionComment)
                  : !decisionComment
              ) ||
              buttonLoader
            }
            className="updateProfile"
            onClick={(e) => reviewEIWRSUnblindingRequestData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Reviewing...
              </div>
            ) : (
              "Review Now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default ReviewStudyUnblindRequestManagement;
